module.exports = __webpack_public_path__ + "static/media/EKEDC.81c16ee3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/discos/EKEDC.svg
// module id = 371
// module chunks = 25